<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-04"></menubar>
    </div>
    <!--  左メニュー 終了 -->
    <!--  ヘッダー行の開始  -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("title.system.owner.title") }}</label>
        <lvory-but
          v-show="this.$IsShowButFun('010204', ownerDetail.deleteFlag, true) "
          @click="deleteOwner"
          slot="cancel">
            {{ $t("button.common.data.delete") }}
        </lvory-but>
        <narrow-down
          @click="ownerEdit"
          v-show="this.$IsShowButFun('010203', ownerDetail.deleteFlag, true) "
          slot="create">
            {{ $t("button.system.building.detail.edit") }}
        </narrow-down>
      </head-title>
    </el-row>
      <!--  ヘッダー行の終わり  -->
    <div slot="body" class="with-100 detail-area">

      <!-- subtitle -->
      <div class="main-title">
        {{$t("title.system.owner.detail")}}
      </div>

      <!-- コンテンツの開始を表示  -->
      <div class="form-group align-items-self-end">
        <div class=" float-left">
          <div class="width-204 lb1">{{"基本情報"}}</div>
        </div>
        <div style="display: flex;width: 100%">
          <div>
            <div class="fm-row form-group m-bottom-5">
              <div class="span-text-size-color  width-136 lb2">{{$t('label.system.owner.detail.ownerExId')}}</div>
              <div class="span-text-size-color m-left-8 lb2 text-placeholder text-word-break" style="width: 32%;">{{ownerDetail.ownerExId}}</div>
            </div>

            <div class="fm-row m-bottom-5 form-group">
              <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.ownerName')}}</div>
              <div class="span-text-size-color m-left-8 text-placeholder text-word-break" style="width: 32%;">{{ownerDetail.ownerName}}</div>
            </div>

          </div>
          <div style="display: flex;flex-direction: column;align-items: flex-end;flex: 1;margin-right: 10%;">
            <!-- <lvory-but
              @click="faqSettingManage"
              class="lvory-btn-width"
              style="margin-bottom: 20px;"
              v-show="this.$IsShowButFun('010217', ownerDetail.deleteFlag, true)">
              {{ $t("button.system.owner.faqsManagingCategories") }}
            </lvory-but> -->
            <lvory-but
              @click="ownerSettingEdit"
              class="lvory-btn-width"
              style="margin-bottom: 20px;"
              v-show="this.$IsShowButFun('010209', ownerDetail.deleteFlag, true)">
              管理メニューを開く
            </lvory-but>
          </div>
        </div>
      </div>

      <hr class="delimiter-80" />

      <div class="form-group align-items-self-end">
        <div class=" float-left">
          <div class="width-204 lb1">{{"基本ポイント設定"}}</div>
        </div>
        <div>
          <div class="fm-row m-bottom-5 fm-row form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.create.pointSime')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.closeDate }}{{ $t('label.system.owner.create.day') }}</div>
          </div>

          <div class="fm-row m-bottom-5 fm-row form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.create.expirationMonth')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.expirationMonth }}{{ $t('label.system.owner.create.month') }}</div>
          </div>

          <div class="fm-row m-bottom-5 form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.pointFeeRate')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.pointFeeRate + "%" }}</div>
          </div>

          <div class="fm-row form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.pointExcRate')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.pointExcRate + "%" }}</div>
          </div>

        </div>
      </div>

      <hr class="delimiter-60" />

      <!-- 所有ビル情報 -->
      <el-row class="m-bottom-35px">
        <span class="title-font-size lb1">
          {{ $t("label.system.owner.detail.allBuildingInformation") }}
        </span>
      </el-row>

      <el-table
        :fit="true"
        width="100%"
        class="table-header-th-top-0"
        style="width: 100% !important;"
        :data="ownerDetail.buildingList">
        <!-- ビルID -->
        <el-table-column
          prop="id"
          class-name="col-3"
          :label="$t('label.system.owner.detail.buildingId')"/>

        <!-- ビル名 -->
        <el-table-column
          prop="name"
          class-name="col-4"
          :label="$t('label.system.owner.detail.buildingName')">
        </el-table-column>

        <!-- 住所 -->
        <el-table-column
          prop="address"
          class-name="col-5"
          :label="$t('label.system.owner.detail.companyAddress')"/>

        <!-- フロア総階数 -->
        <el-table-column
          prop="floor"
          class-name="col-4"
          :label="$t('label.system.owner.detail.totalFloorNumber')"/>
        <!-- 登録済みアカウント数 -->
        <el-table-column
          prop="accountNumber"
          class-name="col-2"
          :label="$t('label.system.owner.detail.accountNumber')"/>

        <!-- アカウント登録上限値 -->
        <el-table-column
          prop="accountlimit"
          class-name="col-2"
          :label="$t('label.system.owner.detail.accountlimit')"/>
      </el-table>

      <hr class="delimiter-60" />

      <div class="form-group align-items-self-end">
        <div class=" float-left">
          <div class="width-204 lb1">{{$t("label.system.owner.detail.responsibleInformation")}}</div>
        </div>
        <div>
          <div class="fm-row form-group m-bottom-5">
            <div class="span-text-size-color  width-136 lb2">{{$t('label.system.owner.detail.respUserName')}}</div>
            <div class="span-text-size-color m-left-8 lb2 text-placeholder text-word-break">{{ ownerDetail.respUser.name }}</div>
          </div>

          <div class="fm-row m-bottom-5 form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.respUserTel')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.respUser.tel }}</div>
          </div>

          <div class="fm-row m-bottom-5 form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.respUserEmail')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break" style="width: 32%;">{{ ownerDetail.respUser.email }}</div>
          </div>

          <div class="fm-row form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.respUserContractNo')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.respUser.contractNo }}</div>
          </div>
        </div>
      </div>

      <hr class="delimiter-60" />

      <div class="form-group align-items-self-end">
        <div class=" float-left">
          <div class="width-204 lb1">{{$t("label.system.owner.detail.headquartersInformation")}}</div>
        </div>
        <div>
          <div class="fm-row form-group m-bottom-5">
            <div class="span-text-size-color  width-136 lb2">{{$t('label.system.owner.detail.companyAddress')}}</div>
            <div class="span-text-size-color m-left-8 lb2 text-placeholder text-word-break" style="width: 32%;">{{ ownerDetail.company.address }}</div>
          </div>

          <div class="fm-row form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.companyTel')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.company.tel }}</div>
          </div>
        </div>
      </div>

      <hr class="delimiter-60" />

      <div class="form-group align-items-self-end">
        <div class=" float-left">
          <div class="width-204 lb1">サービス開通/停止</div>
        </div>
        <div>
          <div class="fm-row form-group m-bottom-5">
            <div class="span-text-size-color  width-136 lb2">{{$t('label.system.owner.detail.serviceStartDt')}}</div>
            <div class="span-text-size-color m-left-8 lb2 text-placeholder text-word-break">{{ ownerDetail.serviceStartDt }}</div>
          </div>

          <div class="fm-row form-group">
            <div class="span-text-size-color width-136 lb2">{{$t('label.system.owner.detail.serviceStopDt')}}</div>
            <div class="span-text-size-color m-left-8 text-placeholder text-word-break">{{ ownerDetail.serviceEndDt }}</div>
          </div>
        </div>
      </div>

      <hr class="delimiter-60" />

      <div class="form-group-start">
        <div class="width-204">
          <!-- ユーザ一覧 -->
          <span class="title-font-size">
            {{ $t("label.system.owner.detail.useList") }}
          </span>
        </div>

          <el-table
            width="100%"
            class="table-header-th-top-0"
            style="width: 100% !important;"
            :data="ownerDetail.userList">
            <!-- 氏名 -->
            <el-table-column
              prop="name"
              class-name="col-2"
              :label="$t('label.system.owner.detail.respUserName')"
            >
              <div slot-scope="scope">
                <span style="cursor:pointer" @click="goAccountDetail(scope.row.id)">{{ scope.row.name }}</span>
              </div>
            </el-table-column>

            <!-- メールアドレス -->
            <el-table-column
              prop="email"
              class-name="col-3"
              :label="$t('label.system.owner.detail.respUserEmail')"
            >
            </el-table-column>

            <!-- ロール -->
            <el-table-column
              prop="role"
              class-name="col-5"
              :label="$t('label.system.owner.detail.role')"
            />

            <!-- SSO対象 -->
            <el-table-column
              v-if="ownerDetail.ssoTargetFlag"
              class-name="col-6"
            >
            <template slot="header" slot-scope="scope">
              <div :id="scope.row">
                SSO対象
              </div>
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.ssoTargetFlag" :disabled="!ownerDetail.ssoTargetChangeEnableFlag" @change="handleUserCheckDetail(scope.row, scope.row.ssoTargetFlag)" />
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>


      <!-- コンテンツの終了を表示  -->

      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import { codeOfValue } from "@/utils/parse-date";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import Menubar from "@/components/leftmenu/DashBoard";
import headTitle from "@/components/common/head/head";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"

export default {
  name: "OwnerDetail",
  components: {
    MainLayout:NewDesignLayout,
    LoadingDialog,
    narrowDown,
    Menubar,
    headTitle,
    LvoryBut,
    elDialogPrompt,
  },
  data() {
    return {
      isShowDeleteBut: true,
      msgParam: this.$t("message.common.validation.deleteMessage",{
        field: "オーナー"
      }),
      ssoBtnIsShow: true,
      resourceBtnIsShow: true,
      centerDialogVisibleIsShow: false,
      checkAllUserDetail: false,
      paramsOwnerId: null,
      showLoading: false,
      ownerDetail: {
        deleteFlag: null,
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        closeDate: 31,
        expirationMonth: 6,
        pointFeeRate: 0,
        pointExcRate: 0,
        ssoTargetFlag: false,
        ssoTargetChangeEnableFlag: false,
        creditFuncFlag: false,
        locationFuncFlag:false,
        outlookSyncFlag:false,
        respUser: {
          name: null,
          tel: null,
          email: null,
          contractNo: null,
        },
        company: {
          address: null,
          tel: null,
        },
        serviceStartDt: null,
        serviceEndDt: null,
        userList: [
          {
            id:null,
            name: null,
            email: null,
            role: null,
            ssoTargetFlag: false
          },
        ],
        buildingList: [
          {
            id: null,
            name: null,
            address: null,
            floor: null,
            accountlimit: null,
            accountNumber: null,
          },
        ],
      },
    };
  },
  created() {
    this.$authCheck("010201")
    if (this.$IsOwnerManager()) {
      this.ssoBtnIsShow = false
      this.resourceBtnIsShow = false
    } else {
      this.ssoBtnIsShow = true
      this.resourceBtnIsShow = true
    }
    this.paramsOwnerId = this.$route.params.ownerId;
    this.ownerDetail.userList = [];
    this.ownerDetail.buildingList = [];
    var breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerBreadDeatil",
      }
    ]
    if (this.$IsOwnerUser()) {
      breadcrumb.splice(2,1)
    }
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  mounted() {
    this.detailOwner();
    this.showBtn();
  },
  methods: {
    codeOfValue,

    showBtn(){
      if (this.$IsOwnerManager()) {
        SystemManageApi.getSystemOrgSso(this.paramsOwnerId)
        .then(({data}) => {
          if (data.body != null && data.body != undefined && data.body != "") {
            if (!this.$IsNullOrEmpty(data.body.policyId) || !this.$IsNullOrEmpty(data.body.azureAdUUID)) {
              this.ssoBtnIsShow = true
            } else {
              this.ssoBtnIsShow = false
            }
          } else {
            this.ssoBtnIsShow = false
          }
        })
        .catch(() => {
          this.ssoBtnIsShow = false
        })
        .finally(() => {
          this.showLoading = false
        })

        SystemManageApi.getResource(this.paramsOwnerId)
        .then(({data}) => {
          if (data.body != null && data.body != undefined && data.body != "") {
            if (data.body.googleResourceAuthInfo != null && data.body.googleResourceAuthInfo != undefined && data.body.googleResourceAuthInfo != "") {
              this.resourceBtnIsShow = true
            }

            if (data.body.outlookResourceAuthInfo != null && data.body.outlookResourceAuthInfo != undefined && data.body.outlookResourceAuthInfo != "") {
              this.resourceBtnIsShow = true
            }
          } else {
            this.resourceBtnIsShow = false
          }

        })
        .catch(() => {
          this.resourceBtnIsShow = false
        })
        .finally(() => {
          this.showLoading = false
        })
      }
    },

    /**
     * オーナー情報
     */
    detailOwner() {
      this.showLoading = true;
      SystemManageApi.detailOwnerForPageInit(this.paramsOwnerId)
       .catch((error) => {
         errorCodeMsg(error, this)
       })
       .then(({ data }) => {
          this.ownerDetail.deleteFlag = data.body.ownerDetail.deleteFlag;
          this.ownerDetail.ownerId = data.body.ownerDetail.id;
          this.ownerDetail.ownerExId = data.body.ownerDetail.exId;
          this.ownerDetail.ownerName = data.body.ownerDetail.name;

          this.ownerDetail.closeDate = data.body.ownerDetail.closeDate;
          this.ownerDetail.expirationMonth = data.body.ownerDetail.expirationMonth;

          this.ownerDetail.ssoTargetFlag = data.body.ownerDetail.ssoTargetFlag;
          this.ownerDetail.ssoTargetChangeEnableFlag = data.body.ownerDetail.ssoTargetChangeEnableFlag;
          this.ownerDetail.creditFuncFlag = data.body.ownerDetail.creditFuncFlag;

          this.ownerDetail.locationFuncFlag = data.body.ownerDetail.locationFuncFlag;
          this.ownerDetail.outlookSyncFlag = data.body.ownerDetail.outlookSyncFlag;

          this.ownerDetail.buildingList = []
          for (let account of data.body.buildingList) {
            this.ownerDetail.buildingList.push({
              id: account.exId,
              name: account.name,
              address: account.address,
              floor: account.aboveFloorCount + account.belowFloorCount,
              accountlimit: account.accountCountLimit,
              accountNumber: account.accountCount
            });
          }
          this.ownerDetail.pointFeeRate = this.$ChangePointRate(data.body.ownerDetail.feeRate);
          this.ownerDetail.pointExcRate = this.$ChangePointRate(data.body.ownerDetail.exchangeRate);

          this.ownerDetail.respUser.name = data.body.ownerDetail.resUserName;
          this.ownerDetail.respUser.tel = data.body.ownerDetail.resUserTelNo;
          this.ownerDetail.respUser.email = data.body.ownerDetail.resUserEmail;
          this.ownerDetail.respUser.contractNo = data.body.ownerDetail.resUserContractNo;


          this.ownerDetail.company.address =
            data.body.ownerDetail.companyAddress;
          this.ownerDetail.company.tel = data.body.ownerDetail.companyTelNo;

          let startDate = data.body.ownerDetail.serviceStartDateTime;
          if(startDate != null && startDate != undefined && startDate != ""){
            this.ownerDetail.serviceStartDt = this.$dateTimeFormat(startDate);
          }
          let endDate = data.body.ownerDetail.serviceEndDateTime;
          if(endDate != null && endDate != undefined && endDate != ""){
            this.ownerDetail.serviceEndDt = this.$dateTimeFormat(endDate);
          }

          this.ownerDetail.userList = []
          this.checkAllUserDetail = true
          for (let user of data.body.accountList) {
            this.ownerDetail.userList.push({
              id:user.id,
              name: user.fullname,
              email: user.email,
              role: codeOfValue(user.roleList),
              ssoTargetFlag: user.ssoTargetFlag
            });
            if (user.ssoTargetFlag === false) {
                this.checkAllUserDetail = false
              }
          }

          this.isShowDeleteBut = this.$IsShowDelButFun("010203", this.ownerDetail.deleteFlag)

       })
       .finally(() => {
          this.showLoading = false;
       });
    },

    /**
     * オーナー一覧
     */
    backOwnerSearch() {
      this.$router.push({
        name: "system-owner-search",
      });
    },

    /**
     *「アカウント情報」画面に遷移する
     * system-account-detail
     */
    goAccountDetail(value){
      this.$router.push({
        name:"system-account-detail",
        params:{
          accountId:value
        }
      })
    },

    isPassParam(param){
      if(param){
        this.doneDeleteOwner();
      }
    },
    /**
     * オーナー削除提示框
     */
    deleteOwner() {
      this.centerDialogVisibleIsShow = true
    },

    /**
     * オーナー削除
     */
    doneDeleteOwner() {
      SystemManageApi.deleteOwner(this.paramsOwnerId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
        .then(({data}) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.backOwnerSearch();
          this.$messageIotSuccess(this.$t("message.common.delete",{
            field: this.$t("label.system.owner.detail.owners")
          }));
        })
        .catch(() => {
          // TODO
        });

    },

    /**
     * オーナー編集
     */
    ownerEdit() {
      this.$router.push({
        name: "system-owner-edit",
        params: {
          ownerId: this.paramsOwnerId,
        },
      });
    },

    // オーナー各種設定
    ownerSettingEdit(){
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.ownerDetail.ownerId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },


    handleUserCheckDetail (info) {
      let idList = []
      idList.push(info.id)
      let body = {
        idList: idList,
        ssoTargetFlag: info.ssoTargetFlag
      }
      this.updatedApi(body)
    },

    handleUserCheckAllDetail () {
      let idList = []
      this.ownerDetail.userList.forEach((info) => {
        info.ssoTargetFlag = this.checkAllUserDetail
        idList.push(info.id)
      })
      let body = {
        idList: idList,
        ssoTargetFlag: this.checkAllUserDetail
      }
      this.updatedApi(body)
    },

    updatedApi (body) {
      this.showLoading = true
      SystemManageApi.putSystemAccountSso(this.ownerDetail.ownerId, body)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(() => {
          this.detailOwner()
          this.$messageIotSuccess(this.$t("message.common.updateSuccess",{
            field: 'SSO対象'
          }))
        }).finally(()=>{
          this.showLoading = false
        })
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
::v-deep.width-450{
  .el-form-item > .el-form-item__label {
    font-size: 16px !important;
    font-weight: 100;
  }
}
.span-text-size-color{
  font-size: 16px !important;
  color: #525250 !important;
}
::v-deep.el-button--text {
    color: #525250;
}

.text-placeholder {
  display: inline-block;
  min-height: 1em;
}

.page-label {
  width: 500px;
  color: #525250;
}

::v-deep .el-form-item>.el-form-item__label{
  font-size: 20px;
  font-weight: 100;
}

.image-slot {
  width: 200px;
  height: 200px;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
.title-font-size{
  font-size: 20px;
  color: #525250;
}
.margin-top-60 {
  margin-top: 60px;
}
::v-deep .el-form-item--small .el-form-item__label {
  font-size: 20px !important;
}
.lable-width {
  width: 544px;
}
.button-width {
  width: 270px;
}
.width-136 {
  width: 146px;
}
.width-270{
  width: 270px;
}
.width-450{
  width: 450px;
}
.width-390{
  width: 390px;
}
.justify-content-flex-end {
  justify-content: flex-end;
}
.lvory-btn-width {
  ::v-deep .my-button{
    width: 315px !important;
  }
}
.align-items-self-end{
  align-items: self-start;
}

.detail-area .lb1, .submit-form .lb1 {
  color: #525250;
}
.width-204 {
  width: 204px;
  margin-top: -4px;
}
/* No.128 */
.hr{
    height: 1px;
    width: 100%;
    background-color: #D1D1CD;
    margin-bottom: 39px;
}
.form-group .m-bottom-7{
  margin-bottom: 40px !important;
}

.m-bottom-60px {
  margin-bottom: 60px !important;
}

.m-bottom-35px {
  margin-bottom: 35px;
}

.form-group-start {
  display: flex;
  align-items: flex-start;
}

.delimiter-80 {
  margin-top:5% !important;
  margin-bottom: 60px !important;
  background-color: #d1d1cd !important;
}
</style>
